import React from "react";
import "./accidentalRepair.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
export default function AccidentalRepair() {
  return (
    <>
<Helmet>
  <title>
    Accidental Car Repair Service in Palwal | AutoCare
  </title>

  <meta
    name="description"
    content="Looking for accidental car repair service in Palwal? AutoCare provides professional accident repair, denting & painting, panel replacement and insurance assistance."
  />

  <link
    rel="canonical"
    href="https://car-repair-mechanic-palwal.netlify.app/services/accidental-repair"
  />
</Helmet>

    <section className="servicePage">
      <div className="serviceContent">

        {/* TEXT SECTION */}
        <div className="textContent">
          <h1>Accidental Car Repair Service in Palwal</h1>

          <p>
            Car accidents can cause serious damage to your vehicle’s body,
            structure, and safety systems. At <strong>AutoCare</strong>, we provide
            professional <span className="highlight">accidental car repair services</span>
            using advanced tools and certified technicians.
            Trusted <strong>Auto Care in Palwal</strong> for complete
            <span className="highlight"> car repair</span>.
          </p>

          <h2>What is Accidental Repair?</h2>
          <p>
            Accidental repair is a comprehensive <span className="highlight">
            car accident repair</span> process that includes fixing structural damage,
            body panels, paintwork, and mechanical issues caused by road accidents.
          </p>

          <h2>Our Accidental Repair Services Include</h2>
          <ul>
            <li>Complete accident damage assessment</li>
            <li>Car body denting & painting</li>
            <li>Chassis alignment & structural repair</li>
            <li>Bumper, bonnet & panel replacement</li>
            <li>Insurance claim assistance</li>
          </ul>

          <h2>Why Choose AutoCare for Accidental Repair?</h2>
          <ul>
            <li>Experienced accident repair specialists</li>
            <li>Modern workshop & genuine spare parts</li>
            <li>Transparent pricing & insurance support</li>
            <li>Trusted <span className="highlight">Auto Care in Palwal</span></li>
            <li>End-to-end <span className="highlight">car repair</span> solution</li>
          </ul>

          <h2>Book Accidental Repair Service with AutoCare</h2>
          <p>
            Searching for reliable <span className="highlight">
            accidental car repair near me</span>?
            Contact <strong>AutoCare</strong> today for fast, safe, and professional repairs.
          </p>

          <button className="primaryBtn">
            <Link to="/contact">
            Book Accidental Repair Service
            </Link>
          </button>
        </div>

        {/* IMAGE SECTION */}
        <div className="imageContent">
          <img
            src="/carServiceImages/accidentalrepair.webp"
            alt="Accidental Car Repair Service in Palwal"
          />
        </div>
      </div>
    </section>
    </>
  );
}
